export default "__VITE_ASSET__DsbL2N1A__"